import React from 'react'

function TheFooter() {
    return (
        <div className="App-footer">
            <div>
                <a href="https://www.segfedpa.com/" target="_blank" rel="noopener noreferrer" className="text-white">Seguros Fedpa, S.A.</a>
                <span className="ml-1">&copy; 2021</span>
            </div>
            <div className="mfs-auto">
                <span className="mr-1">La Fuerza Protectora, 100% Panameña</span>
            </div>
        </div>
    )
}

export default TheFooter
